import update from 'immutability-helper';
import { LOGIN_FAILED, LOGIN_SUCCESS, REQUEST_LOGIN, REMEMBER_ME, FORGET_ME } from '../login/login-actions';
import { LOGOUT, NOT_LOGGED_IN, SESSION_EXPIRED, VIEW_AS_BUSINESS, VIEW_AS_ADMIN } from './auth-actions';

const initialState = {
  isFetching: false,
  isLoggedIn: false, // this is persisted
  sessionExpired: false,

  rememberMe: false, // Remember that they want to be remembered
  rememberedEmail: '', // Only set if remember me is checked

  // {"admin": true,"role": "KiffgoAdmin","business": false}
  admin: false,
  role: null, // owner, ... ?super-admin, admin, business-admin, business-user?
  business: true,
  business_id: null,
  business_name: null,

  // Permissions
  permissions: {},
};

function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return update(state, {
        isFetching: {$set: false},
        isLoggedIn: {$set: true},
        sessionExpired: {$set: false},
        admin: {$set: action.payload.admin},
        role: {$set: action.payload.role.toLowerCase()},
        business: {$set: action.payload.business},
        business_id: {$set: action.payload.business_id},
        business_name: {$set: action.payload.business_name},
        permissions: {$set: action.payload.permissions}
      });
    case VIEW_AS_ADMIN:
      return update(state, {
        business: {$set: false},
        business_id: {$set: null},
        admin: {$set: true}
      });
    case VIEW_AS_BUSINESS:
      return update(state, {
        business: {$set: true},
        business_id: {$set: action.payload.business_id},
      });
    case LOGOUT:
      return update(state, {
        isLoggedIn: {$set: false}
      });
    case REMEMBER_ME:
      return update(state, {
        rememberedEmail: {$set: action.payload.email},
        rememberMe: {$set: true}
      });
    case FORGET_ME:
      return update(state, {
        rememberedEmail: {$set: ''},
        rememberMe: {$set: false}
      });
    case REQUEST_LOGIN:
      return update(state, {
        isFetching: {$set: true}
      });
    case LOGIN_FAILED:
      return update(state, {
        isFetching: {$set: false},
        sessionExpired: {$set: false}
      });
    case NOT_LOGGED_IN:
      return update(state, {
        isFetching: {$set: false},
        sessionExpired: {$set: false},
        isLoggedIn: {$set: false}
      });
    case SESSION_EXPIRED:
      return update(state, {
        isLoggedIn: {$set: false},
        sessionExpired: {$set: true}
      });
    default:
      return state
  }
}

export default authReducer;



// WEBPACK FOOTER //
// ./src/components/auth/auth-reducer.js